// Rounded catalog size for the landing page.
//
// HOW TO UPDATE total sites monitored (yearly — only changes when new
// agencies/facilities are scraped):
//
//   SELECT COUNT(DISTINCT s.id)::int FROM "Site" s;
//
//   Round to a clean number.
//
// (The "alerts sent" headline is computed live in
// AvailabilityNotification.getSentCount() — no hardcoded figure to maintain.)

export const LANDING_STATS = {
  totalSiteCount: 246000, // 246,395 after the six-state USeDirect rollout, rounded
};
